import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import Cookies from 'js-cookie';
import { BASE_URL } from '../http/http';
import axios from 'axios';
import { toast } from 'react-toastify';

const ChooseAvatar = () => {
  const navigate = useNavigate();
 const [selectedAvatar, setSelectedAvatar] = useState(null);

  const [avatars, setAvatars] = useState([])


const getAvatar= async()=>{
      const res = await axios.get(`${BASE_URL}/api/v1/allavatar`)
      const data = res.data
      setAvatars(data)
}

useEffect(() => {
 getAvatar()
}, [])




   const msisdn  =localStorage.getItem('msisdn')
    const redirectURL = localStorage.getItem('redirectUrl')
    const navigateHandler = () => {
      // console.log("userId in age group",getCookie("userId"))
      if (redirectURL) {
      window.location.href = redirectURL;
    } else {
      // console.log("No redirect URL found");
    }
    };  

const updateProfile = async () => {

  const token = localStorage.getItem('token')
  const deviceId= localStorage.getItem('deviceId')
  if (!selectedAvatar) {
    // console.log("No avatar selected");
    return;
  }

  try {
    await axios.put(
      `${BASE_URL}/api/v1/updateprofile`,
      null,
      {
        params: {
          ani: msisdn,
          avatar: selectedAvatar
        },
        headers: {
          Authorization: `Bearer ${token}`,
          "X-Device-Id": String(deviceId)
        }
      }
    );

    toast.success("Profile Updated Successfully");
    navigate("/profile");

  } catch (error) {
    // console.error(error.response?.data || error.message);
    toast.error("Failed to update profile ❌");
  }
};
  return (
    <div className="h-screen bg-black flex justify-center items-center overflow-hidden">
      <div className="w-full  md:max-w-[330px] h-screen bg-black flex flex-col">
        {/* Header */}
        <div className="px-5 py-4 flex items-center justify-between flex-shrink-0">
          <button 
            onClick={() => navigate(-1)} 
            className="text-xl bg-transparent border-2 border-white rounded-lg cursor-pointer w-10 h-10 flex items-center justify-center text-white"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          <h1 className="md:text-2xl text-5xl font-thin text-white">Choose Avatar</h1>
          
        </div>

        {/* Avatar Grid - Larger avatars, tighter spacing */}
        <div className="px-5 md:mt-0 mt-16 md:pt-0 pt-2 md:pb-2 pb-8 flex-shrink-0">
          <div className="grid grid-cols-4 gap-4 mb-8">
            {avatars.map((avatar, index) => (
              <div 
                key={index}
                className="flex justify-center cursor-pointer"
              >
                <div
  onClick={() => setSelectedAvatar(avatar.imageName)}
  className={`w-[78px] md:h-[70px] h-[78px] rounded-full border-2 overflow-hidden bg-gray-800 ${
    selectedAvatar === avatar.imageName
      ? "border-[#00D9FF] scale-105"
      : "border-white"
  }`}
>
                  <img 
                    src={avatar.imageUrl} 
                    alt={avatar.imageName}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Action Buttons - Right after grid */}
          <div className="flex gap-3 ">
            <button className="flex-1 py-3 bg-[#00D9FF] text-black border-none rounded-lg text-lg font-semibold cursor-pointer">
              Create New
            </button>
            <button className="flex-1 py-3 bg-transparent text-[#00D9FF] border-2 border-[#00D9FF] rounded-lg text-lg font-semibold cursor-pointer" onClick={updateProfile}>
              Upload
            </button>
          </div>
        </div>

        {/* Bottom Card - mt-auto pushes it to bottom */}
        <div className="bg-white rounded-t-[30px] px-6 md:pt-5 pt-10 pb-8 flex-shrink-0 mt-auto">
          <h2 className="text-[28px] font-bold text-black text-center mb-3 leading-tight">
            Enter a new<br />Reality!
          </h2>
          <p className="text-3xl text-gray-400 text-center mb-6 leading-relaxed">
            Unlimited Entertainment<br />In a Virtual World!
          </p>
          
          {/* Dots Indicator */}
          <div className="flex justify-center gap-2 mb-3">
            <div className="w-10 h-1 bg-[#00D9FF] rounded-full"></div>
            <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
            <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
          </div>

          <button className="w-full py-4 bg-[#00D9FF] text-black border-none rounded-lg text-xl font-semibold cursor-pointer" onClick={navigateHandler}>
            Start Yo XR Journey
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChooseAvatar;